import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
	changeDetection: ChangeDetectionStrategy.OnPush,
	selector: 'bp-icon-copy',
	templateUrl: './icon-copy.component.svg',
})
export class IconCopyComponent {}
